import { useActionCallback } from "@easybiz/hook";
import { JOB_ACTION_COMPLETE, OPERATION_GROUP_JOB } from "@easybiz/utils";
import { useCallback } from "react";
import { useIntl } from "react-intl";

function useJobComplete(callback) {
  const intl = useIntl();

  const onSubmit = useCallback(({ taskId, note, bags, signature, checkItems }) => {
    return [
      OPERATION_GROUP_JOB,
      JOB_ACTION_COMPLETE,
      {
        ...(note && { note }),
        ...(Array.isArray(bags) && bags.length > 0 && { bags }),
        ...(signature && { signature }),
        ...(Array.isArray(checkItems) && checkItems.length > 0 && { checkItems }),
        taskId,
      },
    ];
  }, []);

  return useActionCallback(onSubmit, callback, intl.formatMessage({ defaultMessage: "Job completed" }));
}

export default useJobComplete;
